import React from 'react'
import { ImageSourcePropType } from 'react-native'
import { PercentageBar } from './PercentageBar'
import styled from 'styled-components/native'
import { atlTheme } from '../../../atlTheme'
import { ProgressBarTitle } from './ProgressBarTitle'
import { platformConfig } from '../../../constants/platform'

const ComponentContainer = styled.View`
  flex-direction: row;
  margin-vertical: ${atlTheme.SpacingAtomic};
`

const IconContainer = styled.Image`
  margin-left: ${atlTheme.SpacingMarginal}px;
  margin-vertical: ${atlTheme.SpacingBase}px;
`

const TextAndBarContainer = styled.View`
  flex-direction: column;
  padding-right: ${atlTheme.SpacingMarginal}px;
  flex: 1;
`

export interface IconAndBarComponentProps {
  title: string
  percentage: number
  icon: ImageSourcePropType
}
export const IconAndBarComponent: React.FunctionComponent<IconAndBarComponentProps> = ({ title, icon, percentage }) => {
  return (
    <ComponentContainer>
      <IconContainer source={icon} />
      <TextAndBarContainer>
        <ProgressBarTitle title={title} percentage={percentage} />
        <PercentageBar
          percentageDone={percentage}
          height={platformConfig.isWeb() ? atlTheme.SpacingDistribute : atlTheme.SpacingBase}
          borderRadius={platformConfig.isWeb() ? atlTheme.SpacingDistribute : atlTheme.SpacingBase}
          marginLeft={atlTheme.SpacingBase}
        />
      </TextAndBarContainer>
    </ComponentContainer>
  )
}
